var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0288 22C6.50596 22 2.02881 17.5228 2.02881 12C2.02881 6.47715 6.50596 2 12.0288 2C17.5516 2 22.0288 6.47715 22.0288 12C22.0288 17.5228 17.5516 22 12.0288 22ZM9.73883 19.6674C8.77624 17.6259 8.18613 15.3742 8.05612 13H4.0907C4.48681 16.1765 6.7452 18.7747 9.73883 19.6674ZM10.0595 13C10.2099 15.4388 10.9066 17.7297 12.0288 19.752C13.151 17.7297 13.8477 15.4388 13.9981 13H10.0595ZM19.9669 13H16.0015C15.8715 15.3742 15.2814 17.6259 14.3188 19.6674C17.3124 18.7747 19.5708 16.1765 19.9669 13ZM4.0907 11H8.05612C8.18613 8.62577 8.77624 6.37407 9.73883 4.33256C6.7452 5.22533 4.48681 7.8235 4.0907 11ZM10.0595 11H13.9981C13.8477 8.56122 13.151 6.27025 12.0288 4.24799C10.9066 6.27025 10.2099 8.56122 10.0595 11ZM14.3188 4.33256C15.2814 6.37407 15.8715 8.62577 16.0015 11H19.9669C19.5708 7.8235 17.3124 5.22533 14.3188 4.33256Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.7ea79a74b9b6fee575f9e0f7cf349146.svg";
export { ForwardRef as ReactComponent };